var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isMobileScreen)?_c('ylFooterRecomMobile',_vm._b({},'ylFooterRecomMobile',_vm.$attrs,false)):_c('ylFooterRecomPC',_vm._b({},'ylFooterRecomPC',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }